module.exports = "https://static.im-cdn.com/mjc/storefront/Simplar/static/media/copy.8b711f5c.svg";